module.exports = __webpack_public_path__ + "static/media/SellerboxGuideShip.ecf9f1c7.png";